export default "__VITE_ASSET__Pkk55ag$__"